// extracted by mini-css-extract-plugin
export default {"header":"index_header__PTGjZ","avatar":"index_avatar__MjDnC","title":"index_title__mD4t8","value":"index_value__49MsJ","closeIcon":"index_closeIcon__zliOi"};